import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  forwardRef
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { clone, KreFormFieldConfig } from "@kre-form/core";
import { IBusinessTable } from "../../tools/util";
import { DataService } from "../../service/data.service";
import * as _ from "lodash";

@Component({
  selector: "kreform-drawer",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
  host: {
    "[class.setting-drawer]": "true"
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KreFormDrawerComponent), // replace name as appropriate
      multi: true
    }
  ]
})
export class KreFormDrawerComponent implements OnInit, OnChanges, OnDestroy {
  visible = false;

  tableData = [];

  constructor() {}

  ngOnInit() {
    //this.initTableData();
  }

  ngOnChanges(changes: SimpleChanges) {}

  ngOnDestroy() {}

  close(): void {
    this.visible = false;
  }

  toggle() {
    this.visible = !this.visible;
  }

  writeValue(value: any) {
    if (value != undefined && value != null) {
      this.tableData = value;
    }
  }

  onChange(_: any) {}
  onTouched() {}
  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}
